import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const BusinessInvestmentSummary = ({ investorResult }) => {
  if (!investorResult) {
    return <div className="text-center text-gray-500">No data available for Business Investment.</div>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-6 space-y-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold text-center text-purple-800 mb-6">Business Investment Summary</h2>

      <div className="bg-gray-50 rounded-lg p-6 space-y-4">
        <h3 className="text-center text-xl font-semibold mb-4 text-purple-700">Investor</h3>
        <div className="grid grid-cols-2 gap-2 text-sm">
          <div>Initial Investment:</div>
          <div className="font-semibold">{formatCurrency(investorResult.originalPropertyValue)}</div>

          <div>Final Business Value:</div>
          <div className="font-semibold">{formatCurrency(investorResult.finalValue)}</div>

          <div>Appreciation:</div>
          <div className="font-semibold">{formatCurrency(investorResult.assetAppreciation)}</div>

          <div>Total ROI:</div>
          <div className="font-semibold">{investorResult.totalROI}%</div>

          <div>Annualized ROI:</div>
          <div className="font-semibold">{investorResult.annualizedROI}%</div>

          <div>IRR Estimate:</div>
          <div className="font-semibold">{investorResult.irrEstimate}%</div>
        </div>

        <p className="text-xs text-gray-400 text-center mt-4">
          * Valuation based on projected revenue growth and market multiplier over {investorResult.termYears} years.
        </p>
      </div>
    </div>
  );
};

export default BusinessInvestmentSummary;
